// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-toolbar {
    width: 100%;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    box-shadow: none;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 5px 16px;

    display: flex;
    justify-content: space-between;
    align-items: center;
}

.file-toolbar-left,
.file-toolbar-right {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.file-toolbar button {
    border: none;
    background-color: transparent;

    box-shadow: none;
    min-height: 28px;
    min-width: 40px;
    padding: 0 8px;
    transition: all 0.5s;

    display: flex;
    justify-content: center;
    align-items: center;
}

.file-toolbar button:hover {
    background: #5c636a;
    border-color: #6c757d;
    border-style: solid;
    border-width: 0;
    border-radius: 4px;
    color: #fff;
}



.file-toolbar-info {
    padding-left: 2px!important;
}

.file-toolbar button:disabled {
    pointer-events: none;
    opacity: .3;
}



@media only screen and (max-width: 1460px) { 
    .file-toolbar-right .file-toolbar-info {
        display: none;
    }

}


@media only screen and (max-width: 1400px) { 
    .file-toolbar-left .file-toolbar-info {
        display: none;
    }

}
`, "",{"version":3,"sources":["webpack://./app/src/js/components/filemanager/file-toolbar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;;IAEjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,6BAA6B;;IAE7B,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,oBAAoB;;IAEpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;;;AAIA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,WAAW;AACf;;;;AAIA;IACI;QACI,aAAa;IACjB;;AAEJ;;;AAGA;IACI;QACI,aAAa;IACjB;;AAEJ","sourcesContent":[".file-toolbar {\n    width: 100%;\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    box-shadow: none;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    padding: 5px 16px;\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.file-toolbar-left,\n.file-toolbar-right {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.file-toolbar button {\n    border: none;\n    background-color: transparent;\n\n    box-shadow: none;\n    min-height: 28px;\n    min-width: 40px;\n    padding: 0 8px;\n    transition: all 0.5s;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.file-toolbar button:hover {\n    background: #5c636a;\n    border-color: #6c757d;\n    border-style: solid;\n    border-width: 0;\n    border-radius: 4px;\n    color: #fff;\n}\n\n\n\n.file-toolbar-info {\n    padding-left: 2px!important;\n}\n\n.file-toolbar button:disabled {\n    pointer-events: none;\n    opacity: .3;\n}\n\n\n\n@media only screen and (max-width: 1460px) { \n    .file-toolbar-right .file-toolbar-info {\n        display: none;\n    }\n\n}\n\n\n@media only screen and (max-width: 1400px) { \n    .file-toolbar-left .file-toolbar-info {\n        display: none;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
